import { createRoot } from 'react-dom/client'
import { lazy, StrictMode, Suspense } from 'react'
import { kcContext as kcLoginThemeContext } from './keycloak-theme/login/kcContext'
import './index.css'

const App = lazy(() => import('./App'))
const KcLoginThemeApp = lazy(() => import('./keycloak-theme/login/KcApp'))

if (kcLoginThemeContext !== undefined) {
  console.log(kcLoginThemeContext)
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense>
      {(() => {
        if (kcLoginThemeContext !== undefined) {
          return <KcLoginThemeApp kcContext={kcLoginThemeContext} />
        }

        return <App />
      })()}
    </Suspense>
  </StrictMode>
)
